export enum Prefix {
  Last = 'last',
  Week = 'weekly',
}

export enum Suffix {
  Week = 'week',
  Month = 'month',
}

// Define a type for week numbers (1-52)
export type WeekNumber = number

// Define date range type with ISO string timestamps
export type DateRange = {
  start: string // ISO string
  end: string // ISO string
}

// Define the possible time configurations
export type LastTimeConfig = {
  prefix: Prefix.Last
  suffix: Suffix
  range: DateRange
}

export type WeekTimeConfig = {
  prefix: Prefix.Week
  weekNumber: WeekNumber // Week number (1-52)
  range: DateRange
}

// Union type for all possible time configurations
export type TimeConfig = LastTimeConfig | WeekTimeConfig

export type InsightStore = {
  time: TimeConfig
  setPrefix: (prefix: Prefix) => void
  setSuffix: (suffix: Suffix) => void
  setWeekNumber: (weekNumber: WeekNumber) => void
}
